/*
 * buecherglanz — 2026-09-19
 * Grund: Design-Paket „Maison buecherglanz“ – „Passend dazu“ im Warenkorb-Drawer (siehe snippets/bg-cart-recs.liquid).
 * Funktion:
 *   · lädt die Vorschläge erst, wenn der Drawer offen ist (spart Anfragen für alle, die den Warenkorb nicht öffnen)
 *   · zuerst „ergänzende“, ohne Treffer „verwandte“ Produkte; Artikel im Warenkorb werden ausgelassen; max. 2 Einträge
 *   · „Dazu“ legt per Cart-API in den Warenkorb und rendert den Drawer über die Theme-eigene Methode neu
 *     (cart-drawer.renderContents) → Summe, Versandfrei-Balken und Zähler aktualisieren sich wie gewohnt
 * Ohne Abhängigkeiten, lädt mit defer. Ergebnisse werden pro Warenkorb-Stand zwischengespeichert.
 */
(function () {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer || window.bgCartRecsReady) return;
  window.bgCartRecsReady = true;

  const cache = new Map();
  const MAX_ITEMS = 2;

  const fetchItems = async (box, intent) => {
    const url = `${box.dataset.url}?section_id=bg-cart-recs&product_id=${box.dataset.productId}&limit=6&intent=${intent}`;
    const response = await fetch(url);
    if (!response.ok) return [];
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const exclude = (box.dataset.exclude || '').split(',');
    return [...html.querySelectorAll('.bg-cart-recs__item')].filter((item) => !exclude.includes(item.dataset.productId));
  };

  const load = async (box) => {
    if (!box || box.dataset.bgLoaded) return;
    box.dataset.bgLoaded = 'true';
    const key = `${box.dataset.productId}|${box.dataset.exclude}`;
    try {
      if (!cache.has(key)) {
        let items = await fetchItems(box, 'complementary');
        if (items.length === 0) items = await fetchItems(box, 'related');
        cache.set(key, items.slice(0, MAX_ITEMS).map((item) => item.outerHTML).join(''));
      }
      const markup = cache.get(key);
      if (!markup) return;
      box.querySelector('[data-bg-cart-recs-list]').innerHTML = markup;
      box.hidden = false;
    } catch (error) {
      console.error('bg-cart-recs', error);
    }
  };

  const check = () => {
    if (drawer.classList.contains('active')) load(drawer.querySelector('[data-bg-cart-recs]'));
  };
  new MutationObserver(check).observe(drawer, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: true,
  });

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('button.bg-cart-recs__add');
    if (!button) return;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const body = { items: [{ id: Number(button.dataset.variantId), quantity: 1 }] };
    if (typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
    }
    try {
      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const state = await response.json();
      if (!response.ok || state.status) throw new Error(state.description || 'add failed');
      drawer.renderContents(state);
      // PUB_SUB_EVENTS ist in constants.js als globale const deklariert (kein window-Property)
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bg-cart-recs', cartData: state });
      }
    } catch (error) {
      console.error('bg-cart-recs', error);
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();